export const domesticPartyRatios = [0.5237620229, 0.07937312165, 0.001229394653, 0.0027, 0.1731, 0.1775, 0.0076, 0.0405];
// export const domesticVotes = 48631366;
// export const abroadVotes = 1505809;
// export const totalVotes = 50137175; // 48631366 + 1505809;
export const abroadVoteRatio = 0.03096374056; // abroadVotes / domesticVotes
export const abroadPartyRatios = [0.5173, 0.0801, 0.0013, 0.0027, 0.1731, 0.1775, 0.0076, 0.0405];
